var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("v-breadcrumbs", {
        staticClass: "d-sm-none d-inline-block",
        attrs: { items: [_vm.baseItem, _vm.routeItem] },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function (props) {
              return [
                _c("v-breadcrumbs-item", { attrs: { id: props.item.name } }, [
                  props.item === _vm.baseItem
                    ? _c(
                        "div",
                        {
                          staticClass: "d-none d-sm-inline-block",
                          attrs: { transparent: "", "item-value": "key" },
                        },
                        [_vm._v(" " + _vm._s(_vm.baseItem.name) + " ")]
                      )
                    : _vm._e(),
                  props.item === _vm.routeItem
                    ? _c("span", [_vm._v(_vm._s(_vm.$route.name))])
                    : _vm._e(),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("v-breadcrumbs", {
        staticClass: "d-none d-sm-inline-block",
        attrs: { items: [_vm.baseItem, _vm.routeItem] },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function (props) {
              return [
                _c("v-breadcrumbs-item", { attrs: { id: props.item.name } }, [
                  props.item === _vm.baseItem
                    ? _c(
                        "div",
                        {
                          staticClass: "d-none d-sm-inline-block",
                          attrs: { transparent: "", "item-value": "key" },
                        },
                        [_vm._v(" " + _vm._s(_vm.baseItem.name) + " ")]
                      )
                    : _vm._e(),
                  props.item === _vm.routeItem
                    ? _c("span", [_vm._v(_vm._s(_vm.$route.name))])
                    : _vm._e(),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }